<template>
  <transition name="fade">
    <div
      v-show="visible"
      class="back-to-top"
      @click="scrollToTop"
      :style="{ bottom: bottom + 'px', right: right + 'px' }"
    >
      <slot>
        <img src="https://cyvideo.i-oranges.com/home/up.png"  class="btn-to-top" alt="回到顶部">
<!--        <button class="btn-to-top">↑</button>-->
      </slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    // 滚动多少距离后显示按钮
    visibilityHeight: {
      type: Number,
      default: 400
    },
    // 距离底部位置
    bottom: {
      type: Number,
      default: 40
    },
    // 距离右侧位置
    right: {
      type: Number,
      default: 40
    },
    // 滚动动画时长(ms)
    duration: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      visible: false,
      interval: null
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight
    },
    scrollToTop() {
      const start = window.pageYOffset
      const startTime = Date.now()

      const animateScroll = () => {
        const now = Date.now()
        const time = Math.min(1, (now - startTime) / this.duration)
        const easing = time * (2 - time) // 缓动函数
        window.scrollTo(0, Math.ceil(easing * (0 - start) + start))
        if (window.pageYOffset > 0) {
          requestAnimationFrame(animateScroll)
        }
      }

      animateScroll()
    }
  }
}
</script>

<style scoped>
.back-to-top {
  position: fixed;
  cursor: pointer;
  z-index: 1000;
}

.btn-to-top {
  width: 40px;
  height: 40px;
  transition: all 0.3s;
}

.btn-to-top:hover {
  /*background-color: #66b1ff;*/
  transform: scale(1.1);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/BackToTop.vue